import { Timestamp } from "firebase/firestore";
import { CategoriaKOProntofibraDTO } from "./prontofibra.categoriaAttesa.model";

export class ProntofibraDTO {
    id!: number;
    
    codiceStatoProntofibra!: string;

    categoriaKO!: CategoriaKOProntofibraDTO;
    noteKO!: string;

    dataPecOde!: Timestamp;
    dataComunicazioneProntofibra!: Timestamp;
    dataInstallazioneRouter!: Timestamp;
    dataConfermaTS!: Timestamp;
    
}

